import { DateTime } from 'luxon';

/**
 * Builds an array of formatted dates for Fire Danger Ratings (FDR).
 * @returns An array of strings representing today and the next three days in 'dd MMM' format.
 * @example
 * // If today is 01 Jan, the output will be:
 * // ['01 Jan', '02 Jan', '03 Jan', '04 Jan']
 */
export const buildFdrDates = (): string[] => {
  const today = DateTime.now();

  return [
    today.toFormat('dd MMM'),
    today.plus({ days: 1 }).toFormat('dd MMM'),
    today.plus({ days: 2 }).toFormat('dd MMM'),
    today.plus({ days: 3 }).toFormat('dd MMM'),
  ];
};
